import React, { Component } from 'react'
import c from 'classnames'
import PropTypes from 'prop-types'
import Image from 'src/components/image'
import backBtn from 'src/assets/desktop-back-btn.svg'

export class FrameBackBtn extends Component {
  static propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
  }

  static defaultProps = {
    className: '',
    onClick: () => {},
  }

  get className() {
    const { className } = this.props
    return c('im-frame-back-btn', className)
  }

  render() {
    const { className } = this
    const { onClick } = this.props
    return (
      <div className={className} onClick={onClick}>
        <Image src={backBtn} alt="Go Back" />
      </div>
    )
  }
}

export default FrameBackBtn
